import React, { createContext } from 'react';
import { ApartmentCountLimitUseCase } from '../../application/use_cases/apartment_count/ApartmentCountLimitUseCase';
import { apartmentCountLimitUseCase } from '../../config/di/container';

const ApartmentCountLimitsContext = createContext<ApartmentCountLimitUseCase | null>(null);

export const ApartmentCountLimitsProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  return (
    <ApartmentCountLimitsContext.Provider value={apartmentCountLimitUseCase}>
      {children}
    </ApartmentCountLimitsContext.Provider>
  );
};

export const useApartmentCountLimits = () => {
  const context = React.useContext(ApartmentCountLimitsContext);

  if (!context) {
    throw new Error('useApartmentCountLimits must be used within a ApartmentCountLimitsProvider');
  }
  return context;
};
